import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDataQuery, TableDesktopComponent } from '@beego/ngx-table';
import { WaitListDetailsComponent } from '@internal-components/wait-list-components/wait-list-component/wait-list-details.component';
import { WaitListTableFactory } from '@internal-factories/tables/wait-list-table.factory';
import { IWaitListItem } from '@internal-models/wait-list-item.model';
import { WaitListProvider } from '@internal-providers/wait-list.provider';
import { Action, NavigationType, UserPermissions, WaitListItemStatus } from '@shared-libs/enums';
import { MessageService } from '@shared-services/message.service';
import { NavigationService } from '@shared-services/navigation.service';

@Component({
	selector: 'wait-list-desktop-page',
	templateUrl: 'wait-list.desktop.page.html',
	styleUrls: ['./wait-list.desktop.page.scss'],
})
export class WaitListDesktopPage implements AfterViewInit {
	@ViewChild(TableDesktopComponent) private readonly tableComponent: TableDesktopComponent;
	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	public waitListItems: Array<IWaitListItem> = new Array();

	public readonly tableHeaders = WaitListTableFactory.getHeaders();
	public readonly tableFilters = WaitListTableFactory.getFilters();
	public readonly WaitListItemStatus: typeof WaitListItemStatus = WaitListItemStatus;

	constructor(
		private readonly provider: WaitListProvider,
		private readonly navigationService: NavigationService,
		private readonly messageService: MessageService,
		private readonly route: ActivatedRoute
	) {}

	public readonly dataRequest = (query: IDataQuery) => this.provider.getAll(query);

	public ngAfterViewInit(): void {
		this.route.url.subscribe(() => {
			this.tableComponent.refreshData();
		});
	}

	public dataChanged(waitListItems: Array<IWaitListItem>): void {
		this.waitListItems = waitListItems;
	}

	public async createOrUpdate(WaitListItem?: IWaitListItem): Promise<void> {
		void this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.modal, WaitListDetailsComponent, {
				action: WaitListItem ? Action.UPDATE : Action.CREATE,
				waitListItem: WaitListItem,
			})
			.then((result) => {
				if (result?.action) {
					this.tableComponent.refreshData();
					this.messageService.showSavedMessage();
				}
			})
			.catch();
	}
}
